import _ from 'lodash';

import {
    WIN_PROBABILITY,
    TOP_10_PROBABILITY,
    MAKE_CUT_PROBABILITY,
} from '../types';

import dtm from 'scripts/services/dtm';
import { getProbabilityModuleName } from 'components/recap/controllers/analitycs.controller';
import { isPreHole } from 'components/probability/tooltip/tooltip';

export function getPlayerName(player) {
    const firstName = _.get(player, 'firstName');
    const lastName = _.get(player, 'lastName');

    return `${firstName} ${lastName}`;
}

export function formatTabName(tabName) {
    return _.chain(tabName.split(' '))
        .map(
            (word) =>
                `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`,
        )
        .join(' ')
        .value();
}

export function sendTabChangeAnalytics(
    type,
    playerName,
    pageType,
    comparisonNames,
) {
    if (!type || (!playerName && !comparisonNames)) {
        return;
    }

    const moduleName = getProbabilityModuleName(pageType);

    switch (type) {
        case WIN_PROBABILITY:
            dtm.trackWinProbabilityTabClick(
                playerName,
                moduleName,
                comparisonNames,
            );
            break;
        case TOP_10_PROBABILITY:
            dtm.trackTop10ProbabilityTabClick(
                playerName,
                moduleName,
                comparisonNames,
            );
            break;
        case MAKE_CUT_PROBABILITY:
            dtm.trackMakeCutProbabilityTabClick(
                playerName,
                moduleName,
                comparisonNames,
            );
            break;
        default:
            return;
    }
}

export function sendPreProbabilityClick({
    type,
    player,
    pageType,
    compareName,
}) {
    if (!type || !player) {
        return;
    }

    const moduleName = getProbabilityModuleName(pageType);
    const playerName = getPlayerName(player);

    dtm.trackPreProbabilityClicks(
        playerName,
        formatTabName(type),
        moduleName,
        compareName,
    );
}

export function sendChartClickAnalytics({
    type,
    player,
    pageType,
    compareName,
}) {
    if (!type || !player) {
        return;
    }

    const playerName = getPlayerName(player);
    const moduleName = getProbabilityModuleName(pageType);

    dtm.trackProbabilityChartClick(
        playerName,
        formatTabName(type),
        moduleName,
        compareName,
    );
}

export function sendChartAnalytics(params, value) {
    if (isPreHole(value)) {
        return sendPreProbabilityClick(params);
    }

    sendChartClickAnalytics(params);
}

export function sendLatestProbabilityChartAnalytics(params) {
    const playerName = getPlayerName(params.player);
    const sourcePage = 'Latest Probability';

    dtm.trackLatestProbabilityChartClick(playerName, params.type, sourcePage);
}

export function sendVsToggleAnalytics(player) {
    if (!player) {
        return;
    }

    const playerName = getPlayerName(player);

    dtm.trackProbabilityVSToggleChange(playerName);
}

export function sendProbabilityChartArrowClickAnalytics(type, player) {
    if (!type || !player) {
        return;
    }

    dtm.trackProbabilityChartArrowClick(
        getPlayerName(player),
        formatTabName(type),
    );
}
